export default __webpack_public_path__ + "static/media/step_E@2x.00b4c29f.png";